

export default {
  namespaced: true,
  state: {
    comment: null
  },
  getters: {
    comment(state) {
      return state.comment
    },
  },
  actions: {
    setComment({ commit }, payload) {
      commit('setComment', payload)
    },
  },
  mutations: {
    setComment(state, payload) {
      state.comment = payload
    },
  },
}
